import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'
import { stringify } from 'qs'
import * as autosignApiSdk from './api/sdk'

export const autosignApi = createFetchClient<autosignApiSdk.paths>({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  credentials: 'include',
  querySerializer(queryParams) {
    return stringify(queryParams)
  },
})

export const $autosignApi = createClient(autosignApi)
